import "@fontsource/roboto/";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { CircularProgress, Stack } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "api/cached";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { pdfjs } from "react-pdf";
import App from "./app";
import "./localization/i18n-config";
import reportWebVitals from "./reportWebVitals";
import { ThemeConfig } from "./theme/theme";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url,
).toString();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeConfig>
        <Suspense
          fallback={
            <Stack
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                bottom: "0",
                right: "0",
              }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <CircularProgress size={"50px"} />
            </Stack>
          }
        >
          <App />
        </Suspense>
      </ThemeConfig>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

